import { createContext } from 'react';
/**
 * A list of injected dependencies to provide to all loaders as a property on
 * the `loaderInterface`.
 */

export default /*#__PURE__*/createContext([]);